module.exports = __webpack_public_path__ + "static/media/bowel-cancer-news.d9485d41.jpg";